<template>
  <v-row
    v-if="templateConfig.theme !== 'Operator-Template'"
    class="mx-0 mt-0 mb-4 noAnimation"
  >
    <v-col>
      <v-form
        v-model="isValidForm"
        ref="initSubForm"
        @submit="isValidForm && subscribe()"
        onSubmit="return false;"
      >
        <Alert
          :message="error"
          type="error"
          v-if="showError"
          @toggleAlert="showError = !showError"
        />
        <v-row>
          <v-col class="py-0">
            <v-select
              color="success"
              v-model="selectedCountry"
              :rules="countryCodeRules"
              :items="groupedOperatorCountries"
              item-text="countryEnglishName"
              item-value="countryCode"
              :label="merchantConfig.texts.countriesDropDownLabel"
              @change="onChangeCountry()"
              return-object
              :loading="!dataFetched"
              :disabled="!dataFetched"
              :readonly="!merchantConfig.fields[0].isEditable"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row justify-space-between>
          <v-col cols="12" sm="6" class="py-0">
            <v-select
              :readonly="
                operators.length === 1 || !merchantConfig.fields[1].isEditable
              "
              color="success"
              v-model="selectedOperator"
              :rules="operatorCodeRules"
              :items="operators"
              item-text="englishName"
              item-value="operatorCode"
              :label="merchantConfig.texts.operatorsDropDownLabel"
              @change="onChangeOperator()"
              return-object
              :loading="!dataFetched"
              :disabled="!dataFetched"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6" class="py-0" v-if="showMobileNumber">
            <v-text-field
              :readonly="!merchantConfig.fields[2].isEditable"
              class="mobileNumber"
              color="success"
              v-model="mobileNumber"
              :rules="mobileNumberRules"
              :label="merchantConfig.texts.mobileNumberTextFieldLabel"
              :prefix="textFieldPrefix"
              maxlength="13"
              :validate-on-blur="validateMobileOnBlur"
              :loading="!dataFetched"
            ></v-text-field>
          </v-col>
        </v-row>

        <Alert
          :message="operatorAlertMsg"
          type="warning"
          v-if="showOperatorAlert"
        />

        <v-row>
          <v-col>
            <v-btn
              elevation="0"
              block
              :disabled="!isButtonActive"
              :loading="loading"
              :rounded="templateConfig.isButtonRounded"
              class="mainButton"
              id="paymentBtn"
              @click="subscribe()"
            >
              <span v-html="initBtnText" v-if="!loading"></span>
            </v-btn>
          </v-col>
        </v-row>
        <SecondaryDisclaimer
          v-if="
            vatDisclaimerMsg != 'NoDisclaimer' ||
            initSecondaryDisclaimerText ||
            freeStartDisclaimerText
          "
        >
          <div class="secondryDisc">
            <VatDisclaimerMsg :message="vatDisclaimerMsg" />
            <div v-html="freeStartDisclaimerText"></div>
            <div v-html="initSecondaryDisclaimerText"></div>
          </div>
        </SecondaryDisclaimer>
      </v-form>
    </v-col>
  </v-row>

  <!-- Embedded template-->
  <v-row
    v-else-if="templateConfig.theme === 'Operator-Template'"
    class="mx-0 mt-0 mb-4"
  >
    <v-col>
      <v-row class="justify-center">
        <v-col>
          <div
            v-if="this.SubscribeFlowDetails.selectedOperator.englishName"
            class="enterMobileLbl"
          >
            {{
              this.$translate('ENTER_MOBILE_MSG').replace(
                '{operator}',
                this.SubscribeFlowDetails.selectedOperator.englishName
              )
            }}
          </div>
        </v-col>
      </v-row>
      <v-form
        v-model="isValidForm"
        ref="initSubForm"
        @submit="isValidForm && subscribe()"
        onSubmit="return false;"
      >
        <v-row class="justify-center">
          <v-col cols="12" sm="7" md="5" lg="4" xl="3">
            <Alert
              :message="error"
              type="error"
              v-if="showError"
              @toggleAlert="showError = !showError"
            />
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="4" md="3" class="py-0">
            <!-- TODO: maxlength to be dynamic-->
            <v-text-field
              :readonly="!merchantConfig.fields[2].isEditable"
              class="mobileNumber flex-column pt-0"
              color="primary"
              v-model="mobileNumber"
              :rules="mobileNumberRules"
              :prefix="textFieldPrefix"
              maxlength="9"
              :validate-on-blur="validateMobileOnBlur"
              :loading="!dataFetched"
              placeholder="XXXXXXXXX"
            >
              <template v-slot:prepend>
                {{ merchantConfig.texts.mobileNumberTextFieldLabel }}
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="termsCheckbox"
              :label="this.$translate('TermsCheckbox_MSG')"
              color="primary"
              :rules="termsAgreementRules"
              class="checkboxAlignment termsCheckbox"
              off-icon=""
              on-icon=""
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="4" md="3">
            <v-btn
              elevation="0"
              :disabled="!isButtonActive"
              :loading="loading"
              block
              :rounded="templateConfig.isButtonRounded"
              class="mainButton"
              id="paymentBtn"
              @click="subscribe()"
            >
              <span v-html="initBtnText" v-if="!loading"></span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
//1.General imports.
import { mapState, mapMutations } from 'vuex';
import { fraudToolMixin } from '../../Shared/Mixins/fraudToolMixin';
import { startSubscribeMixin } from './startSubscribeMixin.js';
import subscriptionType from '../../../constants/subscriptionType.js';
import mobileNumberRules from '../../Shared/Rules/mobileNumberRules.js';
import requiredRules from '../../Shared/Rules/requiredRules.js';
import {
  digitsConverter,
  removeExtraZero,
  getFormattedMsisdn,
} from '../../../helper/digitsHelper.js';

//2.shared comp. imports.
import { operatorPatternValidationMixin } from '../../Shared/Mixins/operatorPatternValidationMixin';
import VatDisclaimerMsg from '../../Shared/components/VATDisclaimerMsg.vue';
import SecondaryDisclaimer from '../../Shared/components/Disclaimer.vue';
import regex from '../../../constants/regex';
import Alert from '../../Shared/components/Alert.vue';
import saveUserDetails from '../../Shared/API/saveUserDetails';

export default {
  mixins: [operatorPatternValidationMixin, startSubscribeMixin, fraudToolMixin],
  data() {
    return {
      loading: false,
      error: '',
      showError: false,
      operatorAlertMsg: '',
      showOperatorAlert: false,
      groupedOperatorCountries: [],
      operators: [],
      selectedCountry: null,
      selectedOperator: null,
      mobileNumber: '',
      textFieldPrefix: '',
      dataFetched: false,
      vatDisclaimerMsg: '',
      isValidForm: true,
      validateMobileOnBlur: false,
      countryCodeRules: requiredRules(this.$translate, 'COUNTRYREQUIRED'),
      operatorCodeRules: requiredRules(this.$translate, 'OPERATORREQUIRED'),
      termsAgreementRules: requiredRules(),
      saveUserDetails,
      termsCheckbox: false,
      sessionId: new Date().getTime().toString(), // generate guid for fraud package,
    };
  },
  components: {
    VatDisclaimerMsg,
    SecondaryDisclaimer,
    Alert,
  },
  computed: {
    ...mapState(['templateConfig', 'SubscribeFlowDetails', 'merchantConfig']),
    minMobileNumberLength() {
      return this.templateConfig.theme == 'Operator-Template' ? 9 : 8;
    },
    isButtonActive() {
      return this.isValidForm && this.dataFetched;
    },
    showMobileNumber() {
      return (
        this.selectedOperator == null ||
        (this.selectedOperator && !this.selectedOperator.handlesMsisdn)
      );
    },
    initBtnText() {
      //Needs $replacePlaceholders plugin function for [productName] placeholders.
      return this.$replacePlaceholders(this.merchantConfig.texts.initBtn, {
        productName: this.SubscribeFlowDetails.initialProductName,
      });
    },
    initSecondaryDisclaimerText() {
      return this.merchantConfig.texts.initSecondaryDisclaimer;
    },
    freeStartDisclaimerText() {
      //Needs $replacePlaceholders plugin function for [productPrice, currency, frequency, trialPeriod] placeholders.
      if (
        this.SubscribeFlowDetails.selectedOperator &&
        this.SubscribeFlowDetails.freeStartPeriod
      ) {
        return this.$replacePlaceholders(
          this.merchantConfig.texts.freeStartDisclaimer,
          {
            trialPeriod: this.SubscribeFlowDetails.freeTrialDays,
            price:
              this.SubscribeFlowDetails.selectedOperator.disclaimerParams.price,
            currency:
              this.SubscribeFlowDetails.selectedOperator.disclaimerParams
                .currency,
            frequency: this.SubscribeFlowDetails.frequency,
          }
        );
      } else {
        return '';
      }
    },

    mobileNumberRules() {
      return mobileNumberRules(
        this.$translate,
        regex.MOBILE_NUMBER,
        this.merchantConfig?.texts.mobileNumberTextFieldLabel,
        this.minMobileNumberLength
      );
    },
  },
  watch: {
    mobileNumber() {
      if (
        this.mobileNumber &&
        this.mobileNumber.length < this.minMobileNumberLength &&
        regex.MOBILE_NUMBER.test(this.mobileNumber)
      ) {
        this.validateMobileOnBlur = true;
      } else {
        this.validateMobileOnBlur = false;
      }

      this.validateOperatorPattern();
    },
  },
  methods: {
    ...mapMutations(['setSubscribeFlowDetails']),
    async subscribe() {
      if (!this.$refs.initSubForm.validate()) return;

      this.loading = true;

      // clear MSISDN in case of (no MSISDN)
      if (this.selectedOperator.handlesMsisdn) {
        this.mobileNumber = '';
      }

      this.mobileNumber = digitsConverter(this.mobileNumber); //To convert from Hindi to Arabic numbers.
      //No need for "getUserFormattedData()" in start-subscription-step.vue
      //In-case user selected Egypt and entered an Extra zero in mobileNumber textField.
      this.mobileNumber = removeExtraZero(
        this.selectedCountry.countryCode,
        this.mobileNumber
      );

      //validateFraudTool (In fraudToolMixin).
      const validateFraudToolResult = await this.validateFraudTool(
        {
          operatorCode: this.selectedOperator.operatorCode,
          country: this.selectedCountry.twoLetterCountryCode,
          msisdn: this.textFieldPrefix.substring(1) + this.mobileNumber,
          ...this.selectedOperator.merchantAdditionalParams,
        },
        this.sessionId
      );

      if (validateFraudToolResult.isUserClear) {
        this.setSubscribeFlowDetails({
          sessionToken: validateFraudToolResult.sessionToken,
        });
      } else {
        //moveToFailure step with fruadTool failure msg.
        this.setSubscribeFlowDetails({
          step: 4,
          component: 'SubFailure',
          failureMessage: this.$translate('FRAUDTOOLERRORMSG'),
          operationStatusCode: 102, // Note : 102 "operationStatusCode" === Fraud in the back-end.
          reloadInFailure: true,
        });
        return;
      }

      await this.saveUserDetails(
        this.selectedOperator.operatorCode,
        this.textFieldPrefix.substring(1) + this.mobileNumber
      );

      if (
        this.SubscribeFlowDetails.subscriptionType ==
        subscriptionType.FREE_START_PERIOD
      ) {
        // check if already took the free period
        let userShouldGetFreeStartPeriod = await this.$http.get(
          `/sub/UserShouldGetFreeStartPeriod`
        );

        this.setSubscribeFlowDetails({
          userShouldGetFreeStartPeriod: userShouldGetFreeStartPeriod.data,
        });

        if (!userShouldGetFreeStartPeriod.data) {
          // go to confirm-after-trial-period screen
          this.setSubscribeFlowDetails({
            step: 1,
            component: 'SubConfirmationAfterTrial',
            msisdn: this.mobileNumber,
            textFieldPrefix: this.textFieldPrefix,
          });
          this.loading = false;
          this.showError = false;
        } else {
          this.startSubscribe();
        }
      } else {
        this.startSubscribe();
      }
    },
    async initializeFormData() {
      // 1.default case - select the matched operator
      for (let countryIndex in this.groupedOperatorCountries) {
        let country = this.groupedOperatorCountries[countryIndex];

        for (let operatorIndex in country.operatorInfoList) {
          let operator = country.operatorInfoList[operatorIndex];

          if (
            operator.operatorCode === this.SubscribeFlowDetails.operatorCode
          ) {
            this.selectedCountry = country;
            this.operators = country.operatorInfoList;
            this.selectedOperator = operator;
            await this.onChangeOperator();

            if (this.SubscribeFlowDetails.msisdn) {
              this.mobileNumber = getFormattedMsisdn(
                this.SubscribeFlowDetails.msisdn,
                this.selectedCountry.countryCode
              );
            }
            this.textFieldPrefix = '+' + this.selectedCountry.countryCode;
            return;
          }
        }
      }

      // 2.Select the first country otherwise
      if (this.groupedOperatorCountries.length == 1) {
        this.selectedCountry = this.groupedOperatorCountries[0];
        this.operators = this.groupedOperatorCountries[0].operatorInfoList;
        this.selectedOperator =
          this.groupedOperatorCountries[0].operatorInfoList[0];
        await this.onChangeOperator();
        if (this.SubscribeFlowDetails.msisdn) {
          this.mobileNumber = getFormattedMsisdn(
            this.SubscribeFlowDetails.msisdn,
            this.selectedCountry.countryCode
          );
        }
        this.textFieldPrefix = '+' + this.selectedCountry.countryCode;
      }
    },
    async onChangeCountry() {
      this.operators = this.selectedCountry.operatorInfoList;
      this.selectedOperator = this.operators[0]; // set the first operator to be selected
      await this.onChangeOperator();
      this.textFieldPrefix = '+' + this.selectedCountry.countryCode;
    },
    async onChangeOperator() {
      this.validateOperatorPattern();
      this.setSubscribeFlowDetails({ selectedOperator: this.selectedOperator });
      //injectFraudTool from "fraudToolMixin"
      await this.injectFraudTool(
        this.selectedOperator.fraudToolName,
        this.selectedOperator.fraudToolParameters,
        this.sessionId,
        this.selectedOperator.operatorCode,
        this.selectedCountry.twoLetterCountryCode
      );
      //Setting vatDiscalimer on every change in operators dropdown.
      this.vatDisclaimerMsg =
        this.selectedOperator.disclaimerParams.vatDisclaimer;
    },
  },
  async created() {
    await this.includeFraudPackage();
    let response = await this.$http.get(
      `/merchant/operatorproducts?catalogName=${
        this.SubscribeFlowDetails.catalogName
      }&productSKU=${this.SubscribeFlowDetails.initialProductSKU}${
        !this.merchantConfig.fields[1].isEditable
          ? `&operatorCode=` + this.SubscribeFlowDetails.operatorCode
          : ''
      }`
    );

    if (response.data) {
      this.groupedOperatorCountries = Array.isArray(response.data)
        ? response.data
        : [response.data];
    } else {
      //in case Status Code: 204 "no grouped operator countries retruned from API"
      return;
    }

    await this.initializeFormData();
    this.dataFetched = true;
  },

  deactivated() {
    this.loading = false;
  },
};
</script>
